function r(n, q) {
  return n === q || n !== n && q !== q;
}
var c = r;
export {
  c as e
};
